import React, { useEffect, useState } from "react"
import Banner from "../../containers/banner"
import Layout from "../../containers/layout";

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Industry Sectors" body={(
              <>
                <p><a className="text-white" href="/sectors/telecommunication">Telecommunications &gt;</a></p>
                <p><a className="text-white" href="/sectors/telecommunication">FinTech &gt;</a></p>
                <p><a className="text-white" href="/sectors/consumers">Consumers &gt;</a></p>
                <p><a className="text-white" href="/sectors/merchants">Merchants &gt;</a></p>
                <p><a className="text-white" href="/sectors/agri-and-social-tech">Agriculture and Social Technology &gt;</a></p>
                <p><a className="text-white" href="/sectors/iot">Internet of Things &gt;</a></p>
                <p><a className="text-white" href="/sectors/ai">Artificial Intelligence &gt;</a></p>
                <p><a className="text-white" href="/sectors/edge-computing">Edge Computing &gt;</a></p>
              </>
            )}/>
        </Layout>
    )
}

export default IndexPage
